import { throttle } from 'lodash-es';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';

const EVENT_KEY_COUNTER = `.lta.textareacounter`;
const EVENT_KEYUP_COUNTER = `keyup.${EVENT_KEY_COUNTER}`;

class Textarea {
	constructor() {
		this._textAreaCounterEls = SelectorEngine.find('.js-textarea-counter');

		if (this._textAreaCounterEls.length > 0) {
			this.initTextareaCounters(this._textAreaCounterEls);
		}
	}

	initTextareaCounters() {
		this._textAreaCounterEls.forEach((textAreaCounterEl) => {
			// const counterDataAtrributes = Manipulator.getDataAttributes(textAreaCounterEl);
			// const currentValue = Number.parseInt(counterDataAtrributes.counterCurrent, 10);
			// const maxValue = Number.parseInt(counterDataAtrributes.counterMax, 10);
			const textareaEl = SelectorEngine.findOne('textarea', textAreaCounterEl);
			const currentValueEl = SelectorEngine.findOne('#textarea-counter__current', textAreaCounterEl);
			const currentValueMaxLength = SelectorEngine.findOne('#textarea-counter__maximum', textAreaCounterEl);

			if(textareaEl.value.length > 0){
				currentValueEl.textContent = currentValueMaxLength.textContent - textareaEl.value.length
			}

			EventHandler.on(textareaEl, EVENT_KEYUP_COUNTER, throttle(() => {
				currentValueEl.textContent = currentValueMaxLength.textContent - textareaEl.value.length;
			}, 200));
		});
	}
}

const globalTextarea = new Textarea();

export default globalTextarea;
